<!--键值对展示组件-->
<template>
	<div class="columnsContentBody">
		<img :src="getLeftImage">
		<p class="columns">{{columns}}</p>
		<p class="content" @click="$emit('onClick')">{{content}}</p>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
		},
		props: ["img", "columns","content"],
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getLeftImage(){
				return resourcesStore.getters.getResourcesByName('unitInfo/'+this.img+'.png')
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.columnsContentBody{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.columns{
		font-size: 14px;
		margin-right: 30px;
		width: 20%;
	}
	.content{
		font-size: 14px;
		cursor: pointer;
	}
	.columnsContentBody img{
		margin-left: 5%;
		margin-right: 15px;
		width: 25px;
		height: 23px;
	}
</style>